/**
 * Parse JWT payload and extract expiration timestamp.
 * @param {string} token - JWT string
 * @returns {{ exp: number } | null} - Payload with exp (seconds since epoch) or null
 */
export const parseJwtPayload = (token) => {
  if (!token || typeof token !== 'string') return null;
  try {
    const parts = token.split('.');
    if (parts.length !== 3) return null;
    const payload = parts[1];
    const decoded = atob(payload.replace(/-/g, '+').replace(/_/g, '/'));
    return JSON.parse(decoded);
  } catch {
    return null;
  }
};

/**
 * Get access token expiration time in milliseconds since epoch.
 * @param {string} token - JWT access token
 * @returns {number | null} - Expiration time in ms, or null
 */
export const getTokenExpirationMs = (token) => {
  const payload = parseJwtPayload(token);
  if (!payload?.exp) return null;
  return payload.exp * 1000;
};

/**
 * Check if token is expired or will expire within the given buffer (ms).
 * @param {string} token - JWT access token
 * @param {number} [bufferMs=60000] - Buffer: refresh if exp is within this many ms
 * @returns {boolean}
 */
export const isTokenExpiredOrExpiringSoon = (token, bufferMs = 60000) => {
  const expMs = getTokenExpirationMs(token);
  if (!expMs) return true;
  return Date.now() >= expMs - bufferMs;
};
